import { FC, useCallback } from 'react';
import _, { omit } from 'lodash';

import { MidnightQueries, Queries, TableEnterprise } from '@services';

import { Table } from '@molecules';
import { InnerView } from '@templates';

import { ROUTES } from '@constants';
import { useNavigate } from 'react-router-dom';
import { columns } from './utils';

export const EnterpriseTable: FC = () => {
  const navigate = useNavigate();

  const handleOnRowClick = useCallback(
    (id: string) => {
      if (id) {
        sessionStorage.setItem('enterprise-tabs-back-to', window.location.pathname || '');
        sessionStorage.setItem('enterprise-tabs', window.location.search || '');
        const routeUrl = `/${ROUTES.Enterprise}/${id}/${ROUTES.Users}`;
        navigate(routeUrl);
      }
    },
    [navigate],
  );

  const onClick = ({ id }: Partial<TableEnterprise>) => handleOnRowClick(id as string);

  const formatQueriesUsingSearchParams = (queries: Queries | MidnightQueries) => {
    const formattedQueries = Object.entries({
      ...omit(queries, ['filterText', 'filterTextBy']),
    }).reduce((acc, [key, value]) => {
      if (value !== '' && !_.isNil(value)) {
        let formattedValue = value;
        if (key === 'sortOrder') {
          formattedValue = value.toString().toUpperCase();
        }
        if (key === 'pageSize') {
          formattedValue = String(value);
        }
        return { ...acc, [key]: formattedValue };
      }
      return acc;
    }, {});

    const search = (queries as MidnightQueries).filterText || undefined;

    return { ...formattedQueries, search };
  };

  return (
    <InnerView>
      <Table<TableEnterprise>
        queryName="enterprise-organizations"
        columns={columns}
        searchPlaceholder="Search for Enterprise"
        apiRoute="/admin/api/v1/organizations"
        customizeQueries={formatQueriesUsingSearchParams}
        onRowClick={onClick}
        isEnterprise
        usingMidnightResponse
      />
    </InnerView>
  );
};
